import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import React from "react";
import { useGetEmailSignatures } from "../../../hooks";
import { Check } from "lucide-react";

const EmailDetails = ({
  openDetailEmail,
  setOpenDetailEmail,
  signatureId,
}: {
  openDetailEmail: boolean;
  setOpenDetailEmail: (value: boolean) => void;
  signatureId: string;
}) => {
  const { data: emailSignature } = useGetEmailSignatures(
    signatureId,
    openDetailEmail
  );
  const handleCancel = () => {
    setOpenDetailEmail(false);
  };
  return (
    <div>
      {" "}
      <Dialog open={openDetailEmail} onOpenChange={setOpenDetailEmail}>
        <DialogContent className="max-w-xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl">
              {emailSignature?.result?.name}
            </DialogTitle>
            <DialogDescription>
              Full content of the email signature.
            </DialogDescription>
          </DialogHeader>

          <div>
            <label className="text-sm font-medium">Content</label>
            <div className="p-4 bg-muted rounded-md text-sm prose prose-sm max-w-none dark:prose-invert">
              {emailSignature?.result?.preview}
            </div>
          </div>
          {emailSignature?.result?.isDefault && (
            <div className="flex items-center gap-2 text-green-600">
              <Check className="h-4 w-4" />
              <span className="text-sm font-medium">
                This is your default signature
              </span>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EmailDetails;
